import React from 'react';
import { Box, Paper, Stack } from '@mui/material';

import { useIsPhone } from '@hooks';
import { transparentPanelSx } from 'theme/surfaces';

export const ListPage: React.FC<{
  children: React.ReactNode;
  overlays: React.ReactNode;
  plain?: boolean;
}> = ({ children, overlays, plain }) => {
  const isPhone = useIsPhone();

  return (
    <Box
      sx={{
        padding: { xs: '8px', tablet: '16px 24px 16px 16px' },
        overflowY: { xs: 'visible', tablet: 'auto' },
        height: '100%',
      }}
    >
      {plain ? (
        children
      ) : (
        <Paper
          sx={{
            minHeight: '100%',
            backgroundColor: 'white',
            ...(isPhone && transparentPanelSx),
          }}
        >
          <Stack gap={1.5}>{children}</Stack>
        </Paper>
      )}

      {overlays}
    </Box>
  );
};
